import { Box, Heading } from '@chakra-ui/react';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';

type Props = {
  title: string;
  content: string;
};

const SimpleTextSection = ({ content, title }: Props) => (
  <Box
    fontSize="lg"
    lineHeight={2.5}
    as="section"
    maxW="4xl"
    className="content"
    paddingX={[8, null, 10]}
    mx="auto"
  >
    <Heading mb={10} size="xl" fontWeight="bold" color="brand.500" as="h1">
      {title}
    </Heading>
    <ReactMarkdown plugins={[gfm]}>{content}</ReactMarkdown>
  </Box>
);

export default SimpleTextSection;
